import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "agreement" }

import { ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { showToast } from 'vant'
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { getCaptcha, sendSmsCode } from '@/api/system'


export default /*@__PURE__*/_defineComponent({
  __name: 'loginCode',
  setup(__props) {

const store = useStore()

const captcha = ref('')
const captchaUrl = ref('')

// 刷新图形验证码
const refreshCaptcha = async () => {
  try {
    const res = await getCaptcha()
    console.log('res', res);
    captchaUrl.value = URL.createObjectURL(res)
  } catch (error) {
    console.error('验证码获取失败：', error)
  }
}

// 定义表单数据
const phoneAreaPrefix = ref('86')
const phoneNumber = ref('')
const verificationCode = ref('')
const agreed = ref(false)

// 添加倒计时相关变量
const cooldownTime = ref(0)
let timer: ReturnType<typeof setInterval> | null = null

// 表单校验规则
const validatePhoneNumber = () => {
  if (!phoneNumber.value) {
    showToast('请输入手机号')
    return false
  }
  if (!/^1[3-9]\d{9}$/.test(phoneNumber.value)) {
    showToast('请输入正确的手机号')
    return false
  }
  return true
}

const validateVerificationCode = () => {
  if (!verificationCode.value) {
    showToast('请输入验证码')
    return false
  }
  return true
}

const validateAgreement = () => {
  if (!agreed.value) {
    showToast('请先同意隐私政策')
    return false
  }
  return true
}

// 提交表单
const submitForm = () => {
  if (!validatePhoneNumber()) return
  if (!validateVerificationCode()) return
  if (!validateAgreement()) return

  const data = {
    captcha: verificationCode.value,
    password: '',
    phoneAreaPrefix: phoneAreaPrefix.value,
    phoneNumber: phoneNumber.value,
    type: 1
  }
  store.dispatch('user/login', data)
}

// 发送验证码
const sendVerificationCode = () => {
  if (!validatePhoneNumber()) return
  if (cooldownTime.value > 0) return

  try {
    sendSmsCode({
      phoneAreaPrefix: phoneAreaPrefix.value,
      phoneNumber: phoneNumber.value,
      captcha: captcha.value,
      type: 0,
    }).then(res => {
      if (res.code === 200) {
        showToast('发送成功')
        // 开始倒计时
        cooldownTime.value = 60
        timer = setInterval(() => {
          cooldownTime.value--
          if (cooldownTime.value <= 0) {
            if (timer) {
              clearInterval(timer)
              timer = null
            }
          }
        }, 1000)
      } else {
        showToast(res.msg)
        refreshCaptcha()
      }
    })
  } catch (error) {
    console.error(error)
  }
}

const showAreaCodePicker = ref(false)

// 区号数据
const areaCodeColumns = [
  { text: '中国 +86', value: '86' },
  { text: '中国香港 +852', value: '852' },
  { text: '中国澳门 +853', value: '853' },
  { text: '中国台湾 +886', value: '886' },
  { text: '日本 +81', value: '81' },
  { text: '韩国 +82', value: '82' },
  { text: '美国 +1', value: '1' },
]

// 区号选择确认处理函数
const onAreaCodeConfirm = (item: any) => {
  phoneAreaPrefix.value = item.selectedValues[0]
  showAreaCodePicker.value = false
}

onMounted(() => {
  refreshCaptcha()
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  if (captchaUrl.value) {
    URL.revokeObjectURL(captchaUrl.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar),
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "title" }, "验证码登录", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_field, {
          modelValue: phoneNumber.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
          placeholder: "输入手机号",
          border: false
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", {
              class: "country-code",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAreaCodePicker.value = true))
            }, [
              _createVNode(_component_SvgIcon, {
                name: "phone",
                size: "16"
              }),
              _createElementVNode("span", null, "+" + _toDisplayString(phoneAreaPrefix.value), 1),
              _createVNode(_component_van_icon, {
                name: "arrow-down",
                size: "14",
                color: "#666666"
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          modelValue: captcha.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((captcha).value = $event)),
          placeholder: "输入图形验证码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              name: "code",
              size: "16"
            })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_el_image, {
              class: "captcha-img",
              src: captchaUrl.value,
              onClick: refreshCaptcha
            }, null, 8, ["src"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_field, {
          modelValue: verificationCode.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((verificationCode).value = $event)),
          placeholder: "输入验证码",
          border: false
        }, {
          label: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              name: "code2",
              size: "16"
            })
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_button, {
              size: "small",
              plain: "",
              type: "primary",
              onClick: sendVerificationCode,
              disabled: cooldownTime.value > 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cooldownTime.value > 0 ? `${cooldownTime.value}s` : '获取验证码'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        round: "",
        onClick: submitForm
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("登录")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_checkbox, {
          modelValue: agreed.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((agreed).value = $event)),
          shape: "round",
          "icon-size": "12"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" 登录即表示同意"),
            _createElementVNode("a", {
              href: "https://www.jingchat.cn/userProtocol.html",
              target: "_blank"
            }, "《服务条款》", -1),
            _createTextVNode("和"),
            _createElementVNode("a", {
              href: "https://www.hnmengyuqianfang.cn/features.html",
              target: "_blank "
            }, "《隐私协议》", -1)
          ])),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_van_popup, {
        show: showAreaCodePicker.value,
        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showAreaCodePicker).value = $event)),
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_picker, {
            columns: areaCodeColumns,
            onConfirm: onAreaCodeConfirm,
            onCancel: _cache[5] || (_cache[5] = ($event: any) => (showAreaCodePicker.value = false)),
            title: '选择区号',
            "show-toolbar": ""
          })
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})